var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('a',{ref:"exportButton",staticClass:"pill pill-sm pill-dark",attrs:{"href":_setup.exportUrl,"title":"Export"}},[_c('i',{staticClass:"material-icons"},[_vm._v("print")]),_vm._v(" "),_c('span',{staticClass:"pill-label"},[_vm._v("Report")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }